import React from 'react';
import { useRoute } from '@react-navigation/native';

import ServiceNoteButton from './components/ServiceNoteButton';
import { EmptyState, Screen } from '../../design/components';
import { useDriverDay } from './DriverDayProvider';
import StopMachineDetails from './StopMachineDetails';
import { getStopPositionName, getStopSiteName } from './stopDetails';
import useStopDocket from './useStopDocket';

/**
 * The stop's "Machine" quick action: machine and location details of the
 * classic stop screen (communication, temperature, wrap, notes, previous
 * photos, directions, full details). Route params: { docketId }.
 */
const StopMachineView = () => {
	const route = useRoute();
	const day = useDriverDay();
	const { docket, isLoading, error, refetch } = useStopDocket(day, route.params?.docketId);

	return (
		<Screen
			headerRight={<ServiceNoteButton />}
			backLabel="Stop"
			heading={docket?.machine?.assetId ? `Machine ${docket.machine.assetId}` : 'Machine'}
			subheading={docket ? [getStopSiteName(docket), getStopPositionName(docket)].filter(Boolean).join(' · ') : undefined}
			isLoading={isLoading}
			error={error ? 'This stop could not be loaded. Check your connection and try again.' : undefined}
			onRetry={() => refetch()}
		>
			{docket
				? <StopMachineDetails docket={docket} />
				: <EmptyState title="Stop not found" message="This stop may have been removed from its run." />}
		</Screen>
	);
};

export default StopMachineView;
